import { find, map } from 'lodash-es';

import { IMapping } from './uploadModel.service';

class ColumnsOnOfferCtrl {
  static bindings = {
    isFileSelected: '<',
    isLoading: '<',
    error: '<',
    columns: '<',
    mappedColumns: '<'
  };

  columns;
  mappedColumns;

  columnsToRender;

  constructor() {
    //
  }

  $onInit() {
    this.updateColumnsToRender(this.columns, this.mappedColumns);
  }

  // Any time the list of columns changes or a column is mapped/unmapped, update the list
  // More efficient doing it like this than inside the digest cycle
  $onChanges(changes) {
    if (changes.columns || changes.mappedColumns) {
      this.updateColumnsToRender(this.columns, this.mappedColumns);
    }
  }

  // Update the column to reflect whether it is currently mapped to a header
  updateColumnsToRender(newColumns, mappedColumns) {
    let columns: any;

    if (newColumns) {
      columns = map(newColumns, (column: any) => {
        column.mapping = find(
          this.mappedColumns,
          (mappedColumn: IMapping) => column.name == mappedColumn.columnName
        );
        return column;
      });
    }

    this.columnsToRender = columns;
  }

  getDisplayName(column) {
    return (column.required ? '* ' : '') + column.displayName;
  }
}

export const ColumnsOnOfferComponent = {
  template: require('./columnsOnOffer.component.html'),
  controller: ColumnsOnOfferCtrl,
  bindings: ColumnsOnOfferCtrl.bindings
};
